import { useSearchParams } from "react-router-dom";

const months = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];

interface MonthYearFilterProps {
  month: string;
  year: string;
  onChange: (value: { month: string; year: string }) => void;
}

export default function MonthYearFilter({
  month,
  year,
  onChange,
}: MonthYearFilterProps) {
  const thisYear = new Date().getFullYear();
  const years = Array.from({ length: 11 }, (_, i) => String(thisYear - 5 + i));

  const [searchParams, setSearchParams] = useSearchParams();

  const handleMonthChange = (newMonth: string) => {
    onChange({ month: newMonth, year });

    const params = new URLSearchParams(searchParams);
    if (newMonth) {
      params.set("month", newMonth);
    } else {
      params.delete("month");
    }
    params.set("page", "1");
    setSearchParams(params);
  };

  const handleYearChange = (newYear: string) => {
    onChange({ month, year: newYear });

    const params = new URLSearchParams(searchParams);
    if (newYear) {
      params.set("year", newYear);
    } else {
      params.delete("year");
    }
    params.set("page", "1");
    setSearchParams(params);
  };

  return (
    <div className="flex flex-col md:flex-row gap-4 items-center w-full max-w-md">
      {/* Month Picker */}
      <div className="w-full">
        <select
          value={month}
          onChange={(e) => handleMonthChange(e.target.value)}
          className="w-full border rounded-lg px-3 py-2 text-gray-800 shadow-sm focus:outline-none focus:ring-2 focus:ring-indigo-500"
        >
          <option value="">Select Month</option>
          {months.map((m) => (
            <option key={m} value={m}>
              {m}
            </option>
          ))}
        </select>
      </div>

      {/* Year Picker */}
      <div className="w-full">
        <select
          value={year}
          onChange={(e) => handleYearChange(e.target.value)}
          className="w-full border rounded-lg px-3 py-2 text-gray-800 shadow-sm focus:outline-none focus:ring-2 focus:ring-indigo-500"
        >
          <option value="">Select Year</option>
          {years.map((y) => (
            <option key={y} value={y}>
              {y}
            </option>
          ))}
        </select>
      </div>
    </div>
  );
}
